import $ from "jquery";
import HtmlElement from '../../../Elements/HtmlElement';
import { Selectors } from '../Settings';
import {$body} from "../../../Constants";

const NumberOfPeopleSelector = (() => {

	class NumberOfPeopleSelector extends HtmlElement {

		onReady() {
			super.onReady();

			this.select = this._$element.find('select');
			this.selectors = this._$element.find('div');

			this.bindHandlers();
			this.updateDisplay();
		}

		bindHandlers() {
			this.selectors.on('click', e => {
				this.select.val($(e.target).data('people'));
				this.select.trigger('change');
				this.updateDisplay();
			});
		}

		updateDisplay() {
			const number = parseInt(this.select.val()),
				activeSelector = this._$element.find(`div[data-people="${number}"]`);

			this.selectors.removeClass('act');
			activeSelector.add(activeSelector.prevAll('div')).addClass('act');
		}
	}

	return NumberOfPeopleSelector._getElement($body.find(Selectors.NUMBER_OF_PEOPLE_SELECTOR), NumberOfPeopleSelector);
})();

export default NumberOfPeopleSelector;
